import { render } from "./incident-details.vue?vue&type=template&id=0b6716a9&scoped=true"
import script from "./incident-details.vue?vue&type=script&lang=js"
export * from "./incident-details.vue?vue&type=script&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"
import "./incident-details.vue?vue&type=style&index=1&id=0b6716a9&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6716a9"]])

export default __exports__